"use client";
import React from "react";
import Image from "next/image";
import Marquee from "react-fast-marquee";
import { Icon1, Icon2, Icon4, Icon5, Icon6 } from "@/assets";

const logos = [Icon1, Icon2, Icon4, Icon5, Icon6];

function Chip({ src }) {
  return (
    <div className="mx-3 flex h-20 min-w-[190px] items-center justify-center rounded-2xl border border-ink/10 bg-white px-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-editorial">
      <Image src={src} alt="Distribution partner" className="h-8 w-auto object-contain opacity-70 grayscale transition group-hover:opacity-100 md:h-9" style={{ filter: "brightness(0)" }} />
    </div>
  );
}

export default function PartnersBand() {
  return (
    <section className="relative overflow-hidden bg-cream bg-paper-grain py-16 md:py-20">
      {/* soft glows */}
      <div aria-hidden className="pointer-events-none absolute -left-20 top-0 h-56 w-56 rounded-full bg-brand-200/30 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -right-16 bottom-0 h-56 w-56 rounded-full bg-gold-soft/20 blur-3xl" />

      <div className="relative mx-auto max-w-6xl px-4">
        <div className="mb-10 text-center">
          <span className="eyebrow mx-auto flex items-center justify-center gap-3 text-gold-deep">
            <span className="h-px w-8 bg-gold/70" />
            Book Distribution
            <span className="h-px w-8 bg-gold/70" />
          </span>
          <h2 className="mt-4 font-display text-[clamp(1.7rem,3.5vw,2.6rem)] font-semibold text-ink">
            Your Book on Amazon, Barnes &amp; Noble, and Every Major Retailer
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-ink-soft md:text-base">
            Our book publishing and distribution services get your title onto the
            platforms readers already trust — in print, eBook, and audiobook.
          </p>
        </div>
      </div>

      {/* dual opposing marquees */}
      <div className="relative space-y-4">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-cream to-transparent md:w-40" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-cream to-transparent md:w-40" />

        <Marquee speed={38} gradient={false} pauseOnHover autoFill>
          {logos.map((l, i) => (
            <Chip key={`a-${i}`} src={l} />
          ))}
        </Marquee>
        <Marquee speed={38} direction="right" gradient={false} pauseOnHover autoFill>
          {logos.map((l, i) => (
            <Chip key={`b-${i}`} src={l} />
          ))}
        </Marquee>
      </div>

      <div className="relative mx-auto mt-10 flex max-w-6xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-center text-sm text-ink-soft">
        <span className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-gold" />
          40,000+ retail outlets worldwide
        </span>
        <span className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-gold" />
          Print · eBook · Audiobook
        </span>
        <span className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-gold" />
          100% rights &amp; royalties retained
        </span>
      </div>
    </section>
  );
}
